/**
 * 全域除錯開關
 * 設為 true 時啟用所有除錯輸出（LINE alert + 頁面狀態列）
 */
export const DEBUG_MODE = false;
